<template>
  <div class="row justify-content-center">
    <step-back-button v-if="canGoPrevious" @click="this.onPrevious"/>
    <transition v-bind:name="transitionName" mode='out-in'>
      <component v-if="solicitacao" class="form-container" :is='currentStepComponent' :solicitacao="solicitacao" @on-previous="this.onPrevious" @on-submit="this.atualizarSolicitacao" @loading-toggle="handleLoadingToggle"></component>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
  .form-container {
    display: inline-block;
    width: 100%;
  }
</style>

<script>
import ApiClient from '../utils/api-client'
import HubClient from '../utils/hub-consulta-client'
import steps from '@/components/AdditionalInformationPeerToPeer'
import * as mutationTypes from '@/store/mutation-types.js'
import ArrayHelper from '@/utils/array-helper'
import StepBackButton from '@/components/StepBackButton'

let components = Object.assign({StepBackButton}, steps)
 
export default {
  data() {
    return {
      transitionName: 'slide-left',
      solicitacaoId: this.$route.params.id,
      solicitacao: null
    }
  },
  components: components,
  computed: {
    currentStepComponent: function() {
      const stepNames = Object.keys(steps)
      const currentStepName = this.solicitacao ? `${this.solicitacao.Status}-step` : null
      return stepNames.includes(currentStepName) ? currentStepName : 'nome-completo-step'
    },
    progress: function() {
      const stepsAmount = Object.keys(steps).length
      const currentStepNumber = Object.keys(steps).indexOf(this.currentStepComponent) + 1
      return Math.round( (currentStepNumber * 100) / stepsAmount )
    },
    canGoPrevious: function() {
      if(!this.solicitacao) return false

      const stepsThatCantGoBack = ['nome-completo', 'finished', 'cancelado']
      return !stepsThatCantGoBack.includes(this.solicitacao.Status)
    }
  },
  methods: {
    atualizarSolicitacao: function(data) {
      data = Object.assign(data, {StepType: 'next'})
      this.transitionName = 'slide-left'

      this.$store.commit(mutationTypes.START_LOADING)

      //console.log(data);
      // ApiClient.put_GO(`solicitacoes/${this.solicitacaoId}/emprestimo-coletivo-informacoes`, {data: data})
      ApiClient.put(`solicitacoes/${this.solicitacaoId}/emprestimo-coletivo-informacoes`, {data: data})
        .then(response => {
          this.solicitacao = response.data;
          
           this.$store.commit(mutationTypes.STOP_LOADING);
        })
        .catch(error => {
          const errorMessages = error.response ? error.response.data.errors.map(error => error.detail) : error.message
          this.$Notify.error(ArrayHelper.toSentence(errorMessages));
           this.$store.commit(mutationTypes.STOP_LOADING);

        })
        
    },
    onPrevious: function() {
      this.transitionName = 'slide-right'

      this.$store.commit(mutationTypes.START_LOADING)
      // ApiClient.put_GO(`solicitacoes/${this.solicitacaoId}/emprestimo-coletivo-informacoes`, {data: {StepType: 'previous'}})
      ApiClient.put(`solicitacoes/${this.solicitacaoId}/emprestimo-coletivo-informacoes`, {data: {StepType: 'previous'}})
        .then(response => {
          this.solicitacao = response.data
          this.$store.commit(mutationTypes.STOP_LOADING);
        }).catch(()=>{this.$store.commit(mutationTypes.STOP_LOADING);})
        
    },
    handleLoadingToggle(isLoading) {
      if(isLoading) {
        this.$store.commit(mutationTypes.START_LOADING)
      } else {
        this.$store.commit(mutationTypes.STOP_LOADING)
      }
    }
  },
  beforeCreate() {
    const solicitacaoId = this.$route.params.id

    this.$store.commit(mutationTypes.START_LOADING)

    // ApiClient.get_GO(`solicitacoes/${solicitacaoId}`)
    ApiClient.get(`solicitacoes/${solicitacaoId}`)
      .then(response => {
        this.solicitacao = response.data
        this.$store.commit(mutationTypes.STOP_LOADING);
        var email1 = this.solicitacao.Email.trim().toLowerCase();
        var email2 = this.$store.state.currentUser.email.trim().toLowerCase();

        // CADASTRAR TOMADORES NA LISTA ACTIVE CAMPAIN ...
        HubClient.CadastrarTomadorActive(email1)
        // ----------------------------------

        if(email1 != email2) //permissão de visualização somente para o dono da solicitação ( 30/11/2018 - Victor Narcizo)
          window.location.href="#/";
      })
      .catch(error => {
        window.error = error
        if(error.response && error.response.status == 404) {
          this.$router.push('/not-found')
        }

         if(error.response && error.response.status == 401) {
         window.location.href="#/";
        }

        this.$store.commit(mutationTypes.STOP_LOADING);
      })
     
  },
  beforeUpdate() {
    this.$Loading.update(this.progress)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/AdditionalInformationPeerToPeer.vue